export const FETCH_ALL_ORDER_TRANSACTION = 'GET_ALL_ORDER_TRANSACTION';
export const FETCH_ALL_ORDER_TRANSACTION_SUCCEED = 'FETCH_ALL_ORDER_TRANSACTION_SUCCEED';
export const FETCH_ALL_ORDER_TRANSACTION_FAILED = 'FETCH_ALL_ORDER_TRANSACTION_FAILED';

export const FETCH_USER_ORDER_TRANSACTIONS = 'FETCH_USER_ORDER_TRANSACTIONS';
export const FETCH_USER_ORDER_TRANSACTIONS_SUCCEED = 'FETCH_USER_ORDER_TRANSACTIONS_SUCCEED';
export const FETCH_USER_ORDER_TRANSACTIONS_FAILED = 'FETCH_USER_ORDER_TRANSACTIONS_FAILED';

export const FETCH_ID_ORDER_TRANSACTIONS = 'FETCH_ID_ORDER_TRANSACTIONS';
export const FETCH_ID_ORDER_TRANSACTIONS_SUCCEED = 'FETCH_ID_ORDER_TRANSACTIONS_SUCCEED';
export const FETCH_ID_ORDER_TRANSACTIONS_FAILED = 'FETCH_ID_ORDER_TRANSACTIONS_FAILED';

export const WS_EVENT_UPDATE_ORDER_TRANSACTION = 'WS_EVENT_UPDATE_ORDER_TRANSACTION';
export const WS_EVENT_UPDATE_BATCH_ORDER_TRANSACTION = 'WS_EVENT_UPDATE_BATCH_ORDER_TRANSACTION';
